module.exports = __webpack_public_path__ + "static/media/xiaozhuren.5b160982.png";